import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { GazetteService } from '../data/gazette.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { ConfirmDialogService } from 'app/services/shared/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-list-gazettes',
  templateUrl: './list-gazettes.component.html',
  styleUrls: ['./list-gazettes.component.scss']
})
export class ListGazettesComponent implements OnInit {
isSaved = false;
public isLoading = false;
public list:any;
id:any = 0;
  constructor(private routr:Router,private service:GazetteService,private toastService: ToastNotificationService,private confirmDialogService: ConfirmDialogService) { }
  regulatory_eventForm = new FormGroup({
    description: new FormControl(''),
    reg_event_status: new FormControl(1),
    date_scheduled: new FormControl(''), 
  });
  ngOnInit(): void {
    this.getAll();
  }
save(){
  if(!this.regulatory_eventForm.value.description){
    return this.toastService.error('Description is required!','Gazette');
  }
  if(!this.regulatory_eventForm.value.date_scheduled){
    return this.toastService.error('Date Scheduled is required!','Gazette')
  }
  this.isLoading = true;
  this.service.create(this.regulatory_eventForm.value).subscribe((x:any) => {
    this.isSaved = true;
    this.id = x.id;
    this.isLoading = false;
    document.getElementById('closeGazettePopUp').click();
    this.routr.navigateByUrl('/select/gazettes/application/' + x.id)
  })
  
}
saveAndNext(){
  this.isSaved = false;
  this.routr.navigateByUrl('/view/edit/gazettes/'+this.id);
}
getAll(){
  this.isLoading = true;
  this.service.getAll().subscribe( x=>{
    console.log(x);
     this.list = x;
     this.isLoading = false;
  })
}
edit(id){
  this.routr.navigateByUrl('/view/edit/gazettes/'+id);
}
delete(id){
  this.confirmDialogService.confirmThis(
    'Are you sure you want to delete this from the list?',
    () => {
        this.service.deleteRegulatoryEvent(id).subscribe(data =>{
          this.toastService.success('Deteled successfully...','Gazette');
          this.getAll();
        })
    },
    () => {
        //No here
    }
);
}
}
